import { useState, useEffect } from 'react';
import { fetchContent } from '../../services/parameter.service';

const useContentLineaAtencionNacional = () => {
  const [contentLineaAtencionNacional, setContentLineaAtencionNacional] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getContentLineaAtencionNacional = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent('lineaatencionnacional');
      setContentLineaAtencionNacional(responseContent?.data?.list);

      setIsLoading(false);
    } catch (error) {
      console.error(' ERROR EN useContentLineaAtencionNacional --> ', error);
    }
  };

  useEffect(() => {
    getContentLineaAtencionNacional();
  }, []);

  return {
    contentLineaAtencionNacional: contentLineaAtencionNacional,
  };
};

export default useContentLineaAtencionNacional;
